export const getListingChatGPTMessage = (
  type: 'Hotel' | 'Tour' | 'Flight' = 'Hotel'
) => {
  switch (type) {
    case 'Tour':
      return 'Aradığın turu bulmana yardım etmemi ister misin?';
    case 'Hotel':
      return 'Aradığın oteli bulmana yardım etmemi ister misin?';
    case 'Flight':
      return 'Aradığın uçuşu bulmana yardım etmemi ister misin?';
  }
};

export const getDetailChatGPTMessage = (name: string) => {
  return `<b>${name}</b> ile ilgili size yardımcı olmamı ister misiniz?`;
};

export const DEFAULT_CHATGPT_MESSAGE =
  'Ben ChatGPT destekli Setur Seyahat Asistanıyım. Seyahatini planlarken sana yardımcı olmak için tasarlandım. Hayallerindeki seyahati planlamaya hazır mısın :)';
